export const WES_COACH_MODE_ID = 'WES_CHECKOUT';

export type ContextConfigType = {
  config: {
    coachModeId: string;
    coachActionId: string;
  };
  additionalContext: [];
  courseraContext: Record<string, unknown>;
};

export const CONTEXT_CONFIG: ContextConfigType = {
  config: {
    coachModeId: WES_COACH_MODE_ID,
    coachActionId: 'ASSISTANT_PUBLIC',
  },
  additionalContext: [],
  courseraContext: {},
};
